module.exports = __webpack_public_path__ + "static/img/sms-m.9021f62f.png";